export default __webpack_public_path__ + "static/media/bg_download.1e0ab52e.svg";